module.exports = __webpack_public_path__ + "img/no-choco-rating.e37970c2.png";